import { render, staticRenderFns } from "./CopyRender.vue?vue&type=template&id=d477416a&scoped=true"
import script from "./CopyRender.vue?vue&type=script&lang=ts"
export * from "./CopyRender.vue?vue&type=script&lang=ts"
import style0 from "./CopyRender.vue?vue&type=style&index=0&id=d477416a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d477416a",
  null
  
)

export default component.exports